import { NavigationType } from "@/types/navigation";

const navigation: NavigationType[] = [
    {
        label: "Focus",
        isMegaDropdown: true,
        leftPanel: {
            title: "Media & Agencies",
            description: "We partner with forward- thinking agencies to build custom monetization, engagement, and community solutions that power the next digital movement.",
            image: "/images/hero/hero-1.png",
            buttonText: "Get in touch",
            buttonHref: "/contact"
        },
        rightPanel: {
            items: [
                {
                    icon: "ri-lightbulb-line",
                    title: "Startup",
                    description: "Define functional scope of your project to plan project budget and timeline.",
                    href: "/startup"
                },
                {
                    icon: "ri-hand-up-line",
                    title: "Agency & Creator Manager",
                    description: "Designing high-performing digital experiences for a connected future.",
                    href: "/agency-manager"
                },
                {
                    icon: "ri-settings-3-line",
                    title: "Established & Growing",
                    description: "Leveraging modern technology to deliver innovative solutions.",
                    href: "/established-growing"
                },
                {
                    icon: "ri-bar-chart-line",
                    title: "Creator",
                    description: "Crafting result-driven strategies to propel your business forward.",
                    href: "/creator"
                }
            ]
        }
    },
    {
        label: "Services",
        href: "/service",
        isMegaDropdown: true,
        leftPanel: {
            title: "Media & Agencies",
            description: "We partner with forward- thinking agencies to build custom monetization, engagement, and community solutions that power the next digital movement.",
            image: "/images/hero/hero-2.png",
            buttonText: "Get in touch",
            buttonHref: "/service"
        },
        rightPanel: {
            items: [
                {
                    icon: "ri-code-s-slash-line",
                    title: "Strategy & Ideation",
                    description: "Sculpting modern, dynamic web applications for a digital-first world.",
                    href: "/service/strategy-ideation"
                },
                {
                    icon: "ri-smartphone-line",
                    title: "Digital product experiences",
                    description: "Designing high-performing mobile apps for a connected future.",
                    href: "/service/digital-experiences"
                },
                {
                    icon: "ri-brain-line",
                    title: "Technology & Transformation",
                    description: "Leveraging AI & ML to deliver innovative solutions.",
                    href: "/service/technology-transformation"
                },
                {
                    icon: "ri-palette-line",
                    title: "Go-to-market & Growth systems",
                    description: "Enhancing experience with intuitive and user-centric design services.",
                    href: "/service/go-to-market-growth"
                }
            ]
        }
    },
    {
        label: "Work",
        href: "/work"
    },
    {
        label: "Blog",
        href: "/blog"
    },
    {
        label: "About",
        href: "/about"
    },
];

export default navigation;
